"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollSubmited = exports.pollText = exports.pollOption = exports.pollLearnerRoot = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var pollLearnerRoot = function pollLearnerRoot(isSubmitted) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:relative;width:360px;border-radius:3px;background-color:", _themeConfig.default.color.dark.earth, ";display:flex;flex-direction:column;padding:36px 36px 28px;align-items:flex-start;.poll-options{max-height:300px;overflow:auto;width:100%;", !isSubmitted &&
    /*#__PURE__*/
    (0, _emotion.css)("padding-left:10px;margin-left:-10px;padding-top:10px;margin-top:-10px;"), "}.poll-question{font-family:'Playfair Display';margin-bottom:24px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;}.poll-submit,.poll-done{margin-top:33px;}.poll-option + .poll-option{margin-top:16px;}.primary-button{margin-top:42px;}.icon-close{position:absolute;right:5px;top:5px;.IconClose{fill:", _themeConfig.default.color.dark.silver, ";}}.option-percent{font-family:ChronicaPro-Medium;margin-left:12px;margin-right:10px;flex-shrink:0;min-width:45px;text-align:right;}")
  );
};

exports.pollLearnerRoot = pollLearnerRoot;

var pollOption = function pollOption(imageUrl) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)(imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("margin-top:24px !important;"))
  );
};

exports.pollOption = pollOption;
var pollText =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;justify-content:center;.text{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;}&::before,> div::before{display:none !important;}");
exports.pollText = pollText;

var pollSubmited = function pollSubmited(width, isSubmitted, imageUrl, showResults) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)(".poll-option-text{display:flex;position:absolute;width:100%;top:4px;", isSubmitted && imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("top:0px;height:100%;"), "\n    padding-left:10px;}.option-bar{height:100%;position:relative;border-radius:inherit;}&.option{justify-content:space-between;margin-top:10px;border-radius:1.4px;.option-bar-wrapper{flex-grow:1;position:relative;height:32px;background-color:", _themeConfig.default.color.dark.mars, ";border-radius:inherit;", isSubmitted && imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("height:56px;"), "\n      .poll-option-submitted{height:100%;border-radius:inherit;width:", width, "%;", showResults &&
    /*#__PURE__*/
    (0, _emotion.css)("background-color:", _themeConfig.default.color.dark.mercury, ";"), "}.option-text{font-family:ChronicaPro-Medium;line-height:1.5;left:10px;z-index:1;padding-right:6px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;display:flex;}.IconComplete{top:4px;", isSubmitted && imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)("top:0px;height:100%;"), "\n        position:relative;fill:silver;}.poll-option-submitted + .poll-option-submitted{margin-top:4px;}}&.maximum{.option-bar-wrapper{.poll-option-submitted{background-color:", _themeConfig.default.color.dark.emerald, ";border-radius:inherit;}.option-text{font-weight:bold;}.IconComplete{fill:black;}}}&.multipleMaximum{.option-bar-wrapper{.poll-option-submitted{background-color:", _themeConfig.default.color.dark.mercury, ";}.IconComplete{fill:silver;}}}}")
  );
};

exports.pollSubmited = pollSubmited;